/*@flow*/
import tileJSON from 'lib/leaflet-plugins/TileJSONLayer';
import type { RasterTileUrls } from 'lib/getCartoMap';
import type { DeckPropsT } from '../types';
import { useEffect, useState } from 'react';
import useLayer from '../useLayer';

type OptionsT = { tiles: RasterTileUrls };

export default (props: DeckPropsT<OptionsT>) => {
  const [element, setElement] = useState();
  const { options } = props;
  const { tiles } = options;

  useEffect(() => {
    const el = tileJSON({ json: { tiles } });
    setElement(() => el);
  }, []);

  useLayer<OptionsT>(props, element);
};
